import React, { useMemo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Typography } from 'antd'

import { PRIVATE_ROUTES } from '../../routes'
import {
    TalentToolbarProvider,
    useTalentToolbarSlot,
} from './TalentToolbar'
import styles from './talent.module.css'

const { Title } = Typography

/** Main Talent list pages only (not applications / candidate detail / create). */
const getTalentMainPageTitle = (pathname) => {
    const normalized = pathname.replace(/\/$/, '') || pathname

    if (normalized === PRIVATE_ROUTES.jobs) return 'Jobs'
    if (normalized === PRIVATE_ROUTES.candidate.root) return 'Candidates'
    if (normalized === `${PRIVATE_ROUTES.talent}/people`) return 'Resources'
    return null
}

const TalentLayoutInner = () => {
    const toolbar = useTalentToolbarSlot()
    const { pathname } = useLocation()
    const pageTitle = useMemo(
        () => getTalentMainPageTitle(pathname),
        [pathname]
    )
    const isMainPage = Boolean(pageTitle)

    return (
        <div className={styles.pageContainer}>
            {/*
              Always mount the toolbar slot so TalentToolbar portals keep working.
              Only show the title on main list pages.
            */}
            <div
                className={styles.pageHeader}
                style={isMainPage ? undefined : { display: 'none' }}
            >
                <div className={styles.headerBar}>
                    {pageTitle ? (
                        <Title level={3} className={styles.pageTitle}>
                            {pageTitle}
                        </Title>
                    ) : null}
                    <div
                        ref={toolbar?.setSlotEl}
                        className={styles.tabsExtra}
                    />
                </div>
            </div>

            <div className={styles.moduleBody}>
                <Outlet />
            </div>
        </div>
    )
}

const TalentLayout = () => (
    <TalentToolbarProvider>
        <TalentLayoutInner />
    </TalentToolbarProvider>
)

export default TalentLayout
